<script setup lang="ts">
import BaseChip, { type ChipColor } from '@/components/base/BaseChip.vue'
import type { Icons } from '@/components/base/BaseIcon.vue'
const props = defineProps<{
  type: 'optin' | 'has_optin_email'
}>()

const emit = defineEmits<{
  (e: 'change', value: { value: string }): void
}>()

const modelValue = defineModel<string>('modelValue')

const { t } = useI18n()

const colorByValue: Record<string, ChipColor> = {
  '0': 'red',
  '1': 'green',
  null: 'gray'
}

const chipIcon = computed<Icons>(() =>
  props.type === 'optin' ? 'HeroChatBubbleLeftRightIconOutline' : 'HeroEnvelopeIconOutline'
)

const chipLabel = computed(() => t(`pages.customer.customerPage.blocks.create.fields.${props.type}.tag`))

const formattedOptin = computed(() => [
  {
    text: t(`pages.customer.customerPage.blocks.create.fields.${props.type}.unknown.description`),
    value: 'null'
  },
  {
    text: t(`pages.customer.customerPage.blocks.create.fields.${props.type}.true.description`),
    value: '1'
  },
  {
    text: t(`pages.customer.customerPage.blocks.create.fields.${props.type}.false.description`),
    value: '0'
  }
])

const selectedOption = computed(() => formattedOptin.value.find((o) => o.value === modelValue.value))
</script>

<template>
  <Select v-model="modelValue" @update:model-value="(v) => emit('change', { value: v })">
    <SelectTrigger
      class="flex h-10 w-full items-center overflow-hidden text-left hover:border-primary! hover:outline-2! hover:outline-primary!"
    >
      <SelectValue :placeholder="t('pages.import.importPage.mapping.unkownValue')">
        <div v-if="selectedOption" class="flex flex-row items-center gap-2">
          <BaseChip :color="colorByValue[selectedOption.value]" :icon="chipIcon" :text="chipLabel" />
          <span class="text-sm text-foreground">{{ selectedOption.text }}</span>
        </div>
      </SelectValue>
    </SelectTrigger>
    <SelectContent>
      <SelectItem v-for="option in formattedOptin" :key="option.value" :value="option.value">
        <div class="flex flex-row items-center gap-2">
          <BaseChip :color="colorByValue[option.value]" :icon="chipIcon" :text="chipLabel" />
          <span class="text-sm text-foreground">{{ option.text }}</span>
        </div>
      </SelectItem>
    </SelectContent>
  </Select>
</template>
